import { render, staticRenderFns } from "./Toggle.vue?vue&type=template&id=70d03d3a&scoped=true"
var script = {}
import style0 from "./Toggle.vue?vue&type=style&index=0&id=70d03d3a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d03d3a",
  null
  
)

export default component.exports